import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useContext } from 'react';
import { useQueryClient } from 'react-query';
import { getBlob } from '../../store/blob-store';
import { uploadFile } from '../../api/studiesAPI';
import { CleanStudyProcess } from '../../utils/cleanStudyProcess';
import { fileActions } from '../../store/files-slice';
//Import Components
import AuthContext from '../../store/auth-context';
import Button from '../ui/Button';
import WrapperModal from '../ui/WrapperModal';
import ConfirmationWarning from '../ui/ConfirmationWarning';
import ConfirmationWarningCheckbox from '../ui/ConfirmationWarningCheckbox';
import AddReviewDocumentForm from '../forms/AddReviewDocumentForm';
import ConfirmationAlert from '../ui/ConfirmationAlert';
import BillingGridTabs from './BillingGridTabs';
import {
	sendApproval,
	sendToPIApproval,
	userReview,
	getOutputResult
} from '../../api/userReviewAPI';

import './BillingGrid.scss';

const BillingGrid = ({
	studyId,
	billingGridData,
	studyStatus
}) => {
	const queryClient = useQueryClient();
	const authCtx = useContext(AuthContext);
	const [requestReview, setRequestReview] = useState(false);
	const [reviewStep, setReviewStep] = useState('');
	const [sendRequestProcess, setSendRequestProcess] =
		useState(false);
	const [sentToPI, setSentToPI] = useState(false);
	const [acceptCA, setAcceptCA] = useState(false);

	const userReviewsSlice = useSelector(
		(state) => state.reviewsManager.reviews
	);

	const fileSlice = useSelector(
		(state) => state.filesManager.files
	);

	const dispatch = useDispatch();

	const onToggleRequestReviewHandler = (show) => {
		setRequestReview(show);
	};
	const sendRequestHandler = () => {
		setSendRequestProcess(true);
		setReviewStep('UPLOAD_DOCS_WARNING');
	};
	const uploadDocumentProcess = () => {
		setReviewStep('START_UPLOAD_DOCS');
	};
	const sendReview = () => {
		setReviewStep('REVIEW_REQUESTED_ALERT');

		const reviewFileListUploadPromises = fileSlice.map(
			(file) => {
				const currentBlob = getBlob(file.name);
				return uploadFile(file.signedPutUrl, currentBlob);
			}
		);

		const uploadFilesPromise = Promise.all(
			reviewFileListUploadPromises
		);

		uploadFilesPromise
			.then((result) => {
				console.log(result);
				const fileStudyDataList = fileSlice.map((file) => {
					return {
						fileObject: file.name,
						fileType: file.documentType
					};
				});
				const completeUserReviews = [
					...userReviewsSlice,
					...fileStudyDataList
				];
				userReview(completeUserReviews, studyId).then(
					(result) => console.log(result)
				);
			})
			.catch((err) => {
				// TODO handle upload files error
				console.log(err);
				console.log(err.config.data.name);
			});
		CleanStudyProcess();
		dispatch(fileActions.removeAllFiles());
	};
	const cancelReviewCreationHandler = () => {
		sendReview('');
		setSendRequestProcess(false);
	};
	const confirmReviewCreation = () => {
		sendReview('');
		setSendRequestProcess(false);
		setRequestReview(!requestReview);
		queryClient.invalidateQueries('study');
	};
	const sendToPiHandler = () => {
		console.log('sending to P.I approval');
		sendToPIApproval(studyId).then((data) => {
			console.log(data);
		});
		setSentToPI(true);
	};
	const approveHandler = () => {
		setAcceptCA(true);
	};
	const confirmSent = () => {
		setSentToPI(false);
		queryClient.invalidateQueries('study');
	};
	const sentCAHandler = () => {
		console.log('approving');
		sendApproval(studyId).then((data) => {
			console.log(data);
			queryClient.invalidateQueries('study');
		});
		setAcceptCA(false);
	};
	const cancelSentCAHandler = () => {
		setAcceptCA(false);
	};

	const downloadStudyResults = () => {
		console.log('download...');
		getOutputResult(studyId);
	};

	//TODO migrate to new component
	const showButtonCases = (rol, studyStatus) => {
		if (
			rol === 'QA' &&
			studyStatus === 'SUBMITTED_FOR_ANALYSIS'
		) {
			return false;
		} else if (
			rol === 'PI' &&
			studyStatus === 'SUBMITTED_FOR_ANALYSIS'
		) {
			return false;
		} else if (rol === 'QA' && studyStatus === 'ONE') {
			return true;
		} else if (rol === 'PI' && studyStatus === 'ONE') {
			return false;
		} else if (rol === 'QA' && studyStatus === 'TWO') {
			return false;
		} else if (rol === 'PI' && studyStatus === 'TWO') {
			return true;
		} else if (
			rol === 'QA' &&
			studyStatus === 'REVISION_REQUESTED'
		) {
			return false;
		} else if (
			rol === 'PI' &&
			studyStatus === 'REVISION_REQUESTED'
		) {
			return false;
		} else if (
			rol === 'QA' &&
			studyStatus === 'STUDY_COMPLETED'
		) {
			return false;
		} else if (
			rol === 'PI' &&
			studyStatus === 'STUDY_COMPLETED'
		) {
			return false;
		}
	};
	return (
		<>
			<div>
				<BillingGridTabs
					onRequestReview={requestReview}
					billingGridObject={
						billingGridData ? billingGridData : []
					}
					studyId={studyId}
					studyStatus={studyStatus}
				/>
				<div className='billing-grid-controls-buttons'>
					{requestReview && (
						<>
							<Button
								className='btn-default'
								onClick={() =>
									onToggleRequestReviewHandler(false)
								}
							>
								Cancel
							</Button>
							<Button
								className='primary-button'
								onClick={sendRequestHandler}
							>
								Send Request
							</Button>
						</>
					)}
					{!requestReview &&
						showButtonCases(
							authCtx.userData.role,
							studyStatus
						) && (
							<>
								<Button
									className='secondary-button request-review-button'
									onClick={() =>
										onToggleRequestReviewHandler(true)
									}
								>
									Request Review{' '}
								</Button>
								{authCtx.userData.role === 'QA' ? (
									<Button
										className='primary-button send-pi-approval-button'
										onClick={sendToPiHandler}
									>
										Send for P.I. approval
									</Button>
								) : (
									<Button
										className='primary-button pi-approval-button'
										onClick={approveHandler}
									>
										Approve
									</Button>
								)}
							</>
						)}
					{sendRequestProcess && (
						<WrapperModal
							onDismiss={cancelReviewCreationHandler}
						>
							{reviewStep === 'UPLOAD_DOCS_WARNING' && (
								<ConfirmationWarning
									title='Do you want to upload documents to support your comments?'
									subtitle=''
									message=''
									acceptLabel='Upload Documents'
									declineLabel='Send Request Without Documents'
									onAccept={uploadDocumentProcess}
									onDecline={sendReview}
								/>
							)}
							{reviewStep === 'START_UPLOAD_DOCS' && (
								<AddReviewDocumentForm
									docsConfirmLabel='Send Request'
									onDocsConfirm={sendReview}
									onCancel={sendRequestHandler}
								/>
							)}
							{reviewStep === 'REVIEW_REQUESTED_ALERT' && (
								<ConfirmationAlert
									title='The review request has been sent successfully'
									subtitle='The users will be reviewing the items and send you a new billing grid, when its ready we will notify you'
									confirmLabel='Close'
									onConfirm={confirmReviewCreation}
								/>
							)}
						</WrapperModal>
					)}
					{sentToPI && (
						<WrapperModal onDismiss={confirmSent}>
							<ConfirmationAlert
								title='The Coverage Analysis has been sent'
								subtitle='The Coverage Analysis has been sent to the P.I. for the final approval.'
								confirmLabel='Close'
								onConfirm={confirmSent}
							/>
						</WrapperModal>
					)}
					{acceptCA && (
						<WrapperModal onDismiss={cancelSentCAHandler}>
							<ConfirmationWarningCheckbox
								title='The Coverage Analysis has been accepted'
								subtitle='In signing this form, I confirm that all the information contained here is true and correct to the best of knowledge. Here by this is Confirmation of a complete coverage analysis.'
								message='Mark the checkbox to accept the Coverage Analysis'
								acceptLabel='Approve'
								declineLabel='Cancel'
								onAccept={sentCAHandler}
								onDecline={cancelSentCAHandler}
							/>
						</WrapperModal>
					)}
					{(studyStatus === 'STUDY_COMPLETED' ||
						studyStatus === 'ARCHIVED') && (
						<Button
							className='primary-button'
							onClick={downloadStudyResults}
						>
							Download Results
						</Button>
					)}
				</div>
			</div>
		</>
	);
};

export default BillingGrid;
